module.exports = __webpack_public_path__ + "media/product/ctg-3-9831a25d.png";